import axios from 'axios';

export default async function getPublicEvents(
  type?: 'popular' | 'upcoming' | 'recent',
  order_by?: 'start' | '-start' | 'end' | '-end' | 'price' | '-price'
) {
  try {
    const params = new URLSearchParams();
    if (type)
      params.append('type', type);

    if (order_by)
      params.append('order_by', order_by);

    const response = await axios.get(
      `${process.env.NEXT_PUBLIC__APP_API_URL_V1}` + `customer/events/`,
      {
        params,
      },
    );

    return response.data;
  } catch (error) {
    console.error('Failed to fetch events', error);
    throw error;
  }
}
